import * as Api from '@/api';
import tableHeaderName from '@/utils/table_header_name';
import { _restApiDataFormatting } from '@/utils/_function.js';

export default {
  name: 'ContentDetail',
  data() {
    return {
      contentDetail: null,
      history: [],
      fieldsLegalLinks: [
        {
          key: 'creator',
          label: 'Добавил',
          sortable: true
        },
        {
          key: 'date',
          label: 'Дата'
        },
        {
          key: 'url',
          label: 'Ссылка'
        },
        {
          key: 'comment',
          label: 'Комментарий'
        }
      ],
      fields: tableHeaderName.historyFields
    };
  },
  mounted() {
    this.getContentDetailData();
  },
  computed: {
    getContentDetailLoaderStatus() {
      return this.$store.getters.LOADERS.includes('content');
    }
  },
  methods: {
    editContent() {
      this.$router.push({ path: `/content-edit/${this.contentDetail.id}` });
    },

    getContentDetailData() {
      const contentId = this.$route.params.id;
      const blocker = 'content';

      Api.getContentDetailData(contentId, blocker)
        .then((response) => {
          if (response) {
            this.contentDetail = _restApiDataFormatting(response);
          }
        })
        .catch((error) => {
          if (error) {
            this.$rollbar.warning(error);
          }
          this.$toastr('error', this.$t('commonMessage.requestError'), 'Ошибка');
        });
    },

    beforeOpenModal() {
      const body = document.getElementsByTagName('body')[0];
      body.style.overflow = 'hidden';
    },

    beforeCloseModal() {
      const body = document.getElementsByTagName('body')[0];
      body.style.overflow = 'auto';
    }
  }
};
